import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React, { FunctionComponent } from 'react';

interface DeleteBedroomDialogProps {
  open: boolean;
  onCancel: () => void;
  onDelete: () => void;
}

export const DeleteBedroomDialog: FunctionComponent<
  DeleteBedroomDialogProps
> = ({ open, onCancel, onDelete }) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Supprimer la chambre</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Êtes-vous sûr de vouloir supprimer cette chambre ?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Annuler</Button>
        <Button onClick={onDelete} autoFocus sx={{ color: 'error.main' }}>
          Supprimer
        </Button>
      </DialogActions>
    </Dialog>
  );
};
